import CrumbTitle from '@/components/crumbTitle/CrumbTitle';
import { Can } from '@/components/can/Can';
import { PERMS } from '@/features/auth/permissions/permissionKeys';
import { Translation, useDynamicLocale } from '@/hoslog-intl';
import { Payment, PointsIcon, UsersIcon } from '@/icons';
import { createFileRoute, Outlet, useNavigate } from '@tanstack/react-router';
import { Settings } from 'lucide-react';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from 'ui/dropdown-menu';

export const Route = createFileRoute('/(app)/dashboard/referral-reports')({
  loader: () => ({
    crumb: <CrumbTitle id="dashboard.referralReports.crumb.referralReports" icon={UsersIcon} />,
    title: (
      <div className="flex items-center gap-3">
        <Translation id="dashboard.referralReports.pageTitle.referralReports" />
        <ConfigurationMenu />
      </div>
    ),
  }),
  component: RouteComponent,
});

function ConfigurationMenu() {
  const { t } = useDynamicLocale();
  const navigate = useNavigate();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger className="flex cursor-pointer items-center gap-1 text-sm font-medium text-link underline-offset-2 hover:underline">
        <Settings className="size-4" />
        {t('dashboard.referralReports.pageTitle.configuration')}
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-44">
        <Can rule={{ allOf: [PERMS.point.management.list] }}>
          <DropdownMenuItem
            className="cursor-pointer"
            onClick={() =>
              void navigate({
                to: '/points-management/points-configuration',
                search: { activeTab: 'customer', page: 0, fetch: 10 },
              })
            }
          >
            <PointsIcon />
            {t('pointManagement.sidebar.menu.pointsConfiguration')}
          </DropdownMenuItem>
        </Can>
        <Can rule={{ allOf: [PERMS.withdrawal.setup.list] }}>
          <DropdownMenuItem
            className="cursor-pointer"
            onClick={() =>
              void navigate({ to: '/configuration-management/withdrawals-setup', search: { page: 0, fetch: 10 } })
            }
          >
            <Payment />
            {t('configurationManagement.sidebar.menu.withdrawalSetup')}
          </DropdownMenuItem>
        </Can>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

function RouteComponent() {
  return <Outlet />;
}
